const alladddeals = { data: [], loading: true };
export const GetAllAddDeals = (state = alladddeals, action) => {
  switch (action.type) {
    case "get_alladddeals":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
